import { addYears, isAfter, isBefore, subYears } from 'date-fns';

const ERROR_MESSAGE = 'Enter a valid date within 6 years in the past and 5 years in the future';

const TermsStartDateExtendedRangeValidator = {
  isValid: (value: Date | string): boolean => {
    if (!value) {
      return true; // Let required validation handle empty values
    }

    const date = typeof value === 'string' ? new Date(value) : value;

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return false;
    }

    const today = new Date();
    const sixYearsAgo = subYears(today, 6);
    const fiveYearsFromNow = addYears(today, 5);

    // Return true if date is within the allowed range
    return !isBefore(date, sixYearsAgo) && !isAfter(date, fiveYearsFromNow);
  },
  getError: (): string => ERROR_MESSAGE,
};

export default TermsStartDateExtendedRangeValidator;
